<div class="uom"
    fxLayout="row"
    fxLayoutAlign="start center">
    <span class="spacing-right">Units Of Measurement</span>
    <mat-slide-toggle [checked]="metric == true"
        (change)="toggle()">{{ metric == true ? 'Metric' : 'Imperial'}}</mat-slide-toggle>
</div>